/**
 * Created by frank.law on 11/20/17.
 */
import {
    USERNAME_ON_CHANGE,
    PASSWORD_ON_CHANGE,
    AUTH_CODE_CHANGE,
    NEW_PASSWORD_ON_CHANGE,
    CONFIRM_PASSWORD_ON_CHANGE,
    RESET_FORMS,
    SUBMIT_SAML_REQUEST,
    SUBMIT_REGION_REDIRECT_REQUEST
} from '../actions/actions';



export default function forms(state = {}, action) {
    switch (action.type) {
        case USERNAME_ON_CHANGE:
            return Object.assign({}, state, {
                username: action.newValue,
                password: '',
                authCode: ''
            });

        case PASSWORD_ON_CHANGE:
            return Object.assign({}, state, {
                password: action.newValue,
                authCode: ''
            });

        case AUTH_CODE_CHANGE:
            return Object.assign({}, state, {
                authCode: action.newValue
            });

        case NEW_PASSWORD_ON_CHANGE:
            return Object.assign({}, state, {
                password: action.newValue
            });

        case CONFIRM_PASSWORD_ON_CHANGE:
            return Object.assign({}, state, {
                authCode: action.newValue
            });

        case RESET_FORMS:
            return Object.assign({}, state, {
                username: '',
                password: '',
                authCode: ''
            });

        case SUBMIT_SAML_REQUEST:
            return Object.assign({}, state, {
                SAMLRequest: '',
                RelayState: ''
            });

        case SUBMIT_REGION_REDIRECT_REQUEST:
            return Object.assign({}, state, {
                username: ''
            });

        default:
            return state;
    }
}
